export const getGeocode = (address: string) => {
  return {
    method: 'GET',
    url: `${
      process.env.REACT_APP_ORIGIN
    }/locations/geocode?address=${encodeURIComponent(address)}`,
  }
}
